import 'wix-music-widget/lib/index.css';
import {BI_ERRORS} from './logging/errors';
import {logError} from './logging/logging';
import {installUnhandled} from './logging/unhandled';
import {writeOops} from './utils/oops';
import {init} from './widget-player/widget-player';

(function () {
  if (typeof Wix === 'undefined') {
    logError(BI_ERRORS.widget.content.scripts.wix);
    writeOops();
    return;
  }

  if (typeof core === 'undefined') {
    logError(BI_ERRORS.widget.content.scripts.coreJs);
    writeOops();
    return;
  }

  installUnhandled();
  init();
})();



// WEBPACK FOOTER //
// ./widget-player.ts